import { render, staticRenderFns } from "./LunchPlanner.vue?vue&type=template&id=64ae54e2&"
import script from "./LunchPlanner.vue?vue&type=script&lang=js&"
export * from "./LunchPlanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports